<template>
  <div class="instructions">
    <p>{{ $t("components.user.residency_proof_input.instructions.title") }}</p>
    <ul>
      <li>
        <icons-check class="accepted" />
        {{ $t("components.user.residency_proof_input.instructions.documents.drivers_license.base")
        }}{{
          duplicateDriversLicense
            ? $t(
                "components.user.residency_proof_input.instructions.documents.drivers_license.duplicate"
              )
            : ""
        }});
      </li>
      <li>
        <icons-check class="accepted" />
        {{ $t("components.user.residency_proof_input.instructions.documents.utility_bill") }};
      </li>
      <li>
        <icons-check class="accepted" />
        {{ $t("components.user.residency_proof_input.instructions.documents.government_doc") }};
      </li>
      <li>
        <icons-check class="accepted" />
        {{ $t("components.user.residency_proof_input.instructions.documents.bank_doc") }};
      </li>
      <li>
        <icons-check class="accepted" />
        {{ $t("components.user.residency_proof_input.instructions.documents.school_doc") }}.
      </li>
    </ul>
    <p>
      {{ $t("components.user.residency_proof_input.instructions.requirements.title") }}
      <strong
        >{{ $t("components.user.residency_proof_input.instructions.requirements.name") }}, votre
        {{ $t("components.user.residency_proof_input.instructions.requirements.address") }} et la
        {{ $t("components.user.residency_proof_input.instructions.requirements.date") }}</strong
      >. Il doit inclure
      <strong>{{
        $t("components.user.residency_proof_input.instructions.requirements.header")
      }}</strong>
      {{ $t("components.user.residency_proof_input.instructions.requirements.issuer") }}.
      {{ $t("components.user.residency_proof_input.instructions.requirements.validity") }}
    </p>
    <p>{{ $t("components.user.residency_proof_input.instructions.sharing_notice") }}</p>
    <forms-files-uploader
      :id="'residency_proof_' + communityUser.id"
      v-model="proofFiles"
      no-label
      :label="$t('communities.fields.residency_proof')"
      class="mb-0"
      center
      :field="'residency_proof'"
      required
    />
  </div>
</template>

<script>
import IconsCheck from "@/assets/icons/check.svg";
import FormsFilesUploader from "@/components/Forms/FilesUploader.vue";

export default {
  name: "ResidencyProofInput",
  components: {
    "icons-check": IconsCheck,
    FormsFilesUploader,
  },
  props: {
    communityUser: {
      type: Object,
      required: false,
      default: null,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    duplicateDriversLicense: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    proofFiles: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.accepted {
  fill: $success;
}

.instructions {
  ul {
    list-style-type: none;
    padding-left: 1rem;
    li {
      margin-bottom: 0.25rem;
    }
  }
}
</style>
